import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    serviceUnavailable: false,
    serviceRequested: false,
    kubernetes: {},
    kubernetesInitialized: false,
    gettingKurbernetes: false,
    downloadingKurbernetesFile: false,
    creatingKubernetes: false,
    removingKubernetes: false,
    noKubernetes: false,
    plans: [],
    fetchingPlans: false,
    namespaces: [],
    fetchingNamespaces: false,
    addingNamespace: false,
    deletingNamespace: false,
  },
  mutations: {
    SET_SERVICE_UNAVAILABLE(state, value) {
      state.serviceUnavailable = true
      state.serviceRequested = value
    },
    SET_KUBERNETES(state, value) {
      state.kubernetes = value
    },
    SET_CREATING_KUBERNETES(state, value) {
      state.creatingKubernetes = value
    },
    SET_GETTING_KUBERNETES(state, value) {
      state.gettingKurbernetes = value
    },
    SET_DOWNLOADING_KUBERNETES_FILE(state, value) {
      state.downloadingKurbernetesFile = value
    },
    SET_REMOVING_KUBERNETES(state, value) {
      state.removingKubernetes = value
    },
    SET_NO_KUBERNETES(state, value) {
      state.noKubernetes = value
    },
    SET_PLANS(state, data) {
      state.plans = data.result
    },
    SET_FETCHING_PLANS(state, value) {
      state.fetchingPlans = value
    },
    SET_NAMESPACES(state, data) {
      state.namespaces = data.result
    },
    SET_FETCHING_NAMESPACES(state, value) {
      state.fetchingNamespaces = value
    },
    SET_ADDING_NAMESPACE(state, value) {
      state.addingNamespace = value
    },
    ADD_NAMESPACE(state, value) {
      state.namespaces.push(value)
    },
    SET_REMOVING_NAMESPACE(state, value) {
      state.deletingNamespace = value
    },
    SET_KUBERNETES_INITIALIZED(state, value) {
      state.kubernetesInitialized = value
    },
  },
  actions: {
    createKubernetes({ commit }, planId) {
      commit('SET_CREATING_KUBERNETES', true)
      return new Promise((resolve, reject) => {
        api('kyubi')
          .post(`projects/${getProjectId()}/kyubi`, { planId })
          .then(response => {
            commit('SET_KUBERNETES', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_CREATING_KUBERNETES', false)
          })
      })
    },
    getKubernetes({ commit }) {
      commit('SET_GETTING_KUBERNETES', true)
      return new Promise((resolve, reject) => {
        api('kyubi')
          .get(`projects/${getProjectId()}/kyubi`)
          .then(response => {
            commit('SET_KUBERNETES', response.data.result)
            resolve(response)
          })
          .catch(error => {
            if (
              error.response?.status === 426
              || error.response?.status === 428
            ) {
              commit('SET_SERVICE_UNAVAILABLE', error.response?.status === 428)
            }
            if (
              error.response?.status === 404
              || error.response?.status === 409
            ) {
              commit('SET_NO_KUBERNETES', true)
            }
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_KUBERNETES', false)
          })
      })
    },
    downloadKubernetesFile({ commit }) {
      commit('SET_DOWNLOADING_KUBERNETES_FILE', true)
      return new Promise((resolve, reject) => {
        api('kyubi')
          .get(`projects/${getProjectId()}/kyubi?download=true`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_DOWNLOADING_KUBERNETES_FILE', false)
          })
      })
    },
    removeKubernetes({ commit }) {
      commit('SET_REMOVING_KUBERNETES', true)
      return new Promise((resolve, reject) => {
        api('kyubi')
          .delete(`projects/${getProjectId()}/kyubi`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_REMOVING_KUBERNETES', false)
          })
      })
    },
    fetchPlans({ commit }) {
      commit('SET_FETCHING_PLANS', true)
      return new Promise((resolve, reject) => {
        api('kyubi')
          .get(`projects/${getProjectId()}/plans`)
          .then(response => {
            commit('SET_PLANS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_PLANS', false)
          })
      })
    },
    fetchNamespaces({ commit }) {
      commit('SET_FETCHING_NAMESPACES', true)
      return new Promise((resolve, reject) => {
        api('kyubi')
          .get(`projects/${getProjectId()}/namespaces`)
          .then(response => {
            commit('SET_NAMESPACES', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_NAMESPACES', false)
          })
      })
    },
    addNamespace({ commit }, namespace) {
      commit('SET_ADDING_NAMESPACE', true)
      return new Promise((resolve, reject) => {
        api('kyubi')
          .post(`projects/${getProjectId()}/namespaces`, namespace)
          .then(response => {
            commit('ADD_NAMESPACE', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_ADDING_NAMESPACE', false)
          })
      })
    },
    removeNamespace({ commit }, name) {
      commit('SET_REMOVING_NAMESPACE', true)
      return new Promise((resolve, reject) => {
        api('kyubi')
          .delete(`projects/${getProjectId()}/namespaces/${name}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_REMOVING_NAMESPACE', false)
          })
      })
    },
  },
}
